import { IMenuSearchState } from './types';

const state: IMenuSearchState = {
  lookup: '',
  results: [],
  selectedResultIndex: -1,
  cacheSuffix: '',
  mustHaveCacheSuffix: true,
  isSearching: false,
};

export default state;
